import fenligou from "./fenligou.jpg";
import React from "react";

class SeparateDetail extends React.Component {
  render() {
    return (
      <div style={{ minHeight: "100vh", background: "#f3f4f5" }}>
        <img src={fenligou} style={{ width: "100%" }} />
      </div>
    );
  }
}

export default SeparateDetail;



// WEBPACK FOOTER //
// ./src/staticPage/separate/index.js